import {getSelectedAddressID} from '../selectors';

export default (state) => {
  const selectedAddressID = getSelectedAddressID(state);
  const {addresses} = window.start.addresses;
  let addressUuid;
  addresses.forEach((address) => {
    if (address.legacyId === selectedAddressID) {
      addressUuid = {uuid: address.uuid};
    }
  });
  return addressUuid;
};
